export default "<div class=\"academondo-chatbot-container\">\n  <flowise-fullchatbot></flowise-fullchatbot>\n</div>\n"